import { useState } from "react"
import { MapPin, Mail, Phone } from 'lucide-react'
import AnimatedText from '../../AnimatedText'
import './ContactFooterMain.css'
import { postContactUs } from '../../api/api';
// import { ToastContainer, toast } from "react-toastify";
import toast from "react-hot-toast";
import {
    TextField,
    Button,
    Box,
    CircularProgress
} from "@mui/material";


export default function ContactFooterMainSection() {
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [showPopup, setShowPopup] = useState(false);
    const [errors, setErrors] = useState({});
    const [payload, setPayload] = useState({
        name: "",
        mobile_no: "",
        email: "",
        sms: ""
    });

    const valupd = (e) => {
        //
        if (e.target.name === "mobile_no") {
            e.target.value = e.target.value.replace(/\D/g, "");
        }
        //


        setPayload({ ...payload, [e.target.name]: e.target.value });
        if (errors[e.target.name]) {
            setErrors({ ...errors, [e.target.name]: "" });
        }
    }

    const validateForm = () => {
        const newErrors = {};

        if (!payload.name.trim()) {
            newErrors.name = "Full name is required";
        }

        if (!payload.email.trim()) {
            newErrors.email = "Email is required";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(payload.email)) {
            newErrors.email = "Invalid email format";
        }

        if (!payload.mobile_no.trim()) {
            newErrors.mobile_no = "Mobile number is required";
        } else if (!/^[0-9]{10}$/.test(payload.mobile_no)) {
            newErrors.mobile_no = "Mobile number must be 10 digits";
        }

        if (!payload.sms.trim()) {
            newErrors.sms = "Message is required";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        if (validateForm()) {
            fetchPostContactUs(payload);
        }
    }

    const fetchPostContactUs = async (data) => {
        try {
            setLoading(true);
            setMessage("");

            const res = await postContactUs(data);

            if (res?.data?.status === true) {
                setMessage(res?.data?.message || "Thank you for contacting us!");
                // setShowPopup(true);
                setPayload({ name: "", mobile_no: "", email: "", sms: "" });
                setErrors({});
                toast.success(res?.data?.message);
            } else {
                setMessage("Something went wrong. Please try again.");
                toast.error("Something went wrong. Please try again.")
            }
        } catch (err) {
            console.error("Error submitting contact request:", err);
            setMessage("Server error. Please try again later.");
            toast.error(err?.response?.data?.message || "Server error. Please try again later.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="NewsMainContainer">
            <div className="ourPackageUpperSection contact-footer-page">
                <AnimatedText
                    tag="h2"
                    type="words"
                    y={30}
                    className="rb-title ourpackageTitle"
                >
                    Contact Us
                </AnimatedText>
            </div>


            <div className="ContactGridContainer">
                <div className="headcontainer">
                    <span className="heartIcon">We'd ❤️ to help!</span>
                    <br />
                    <span className="contactSubtitle"> We like to create thing with happiness. Feel free to connect with us.</span>

                </div>
                <div className="formcontainer">
                    {/* form section  */}
                    <div className="formsection">
                        {/*  */}

                        <Box
                            component="form"
                            className="contactForm"
                            onSubmit={handleSubmit}
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 2,
                                maxWidth: 600,
                                margin: '0 auto'
                            }}
                        >
                            <TextField
                                fullWidth
                                id="name"
                                name="name"
                                label="Full Name"
                                placeholder="Full Name"
                                value={payload.name}
                                onChange={valupd}
                                error={!!errors.name}
                                helperText={errors.name}
                                required
                                variant="outlined"
                            />

                            <TextField
                                fullWidth
                                id="email"
                                name="email"
                                type="email"
                                label="Email"
                                placeholder="Email"
                                value={payload.email}
                                onChange={valupd}
                                error={!!errors.email}
                                helperText={errors.email}
                                required
                                variant="outlined"
                            />

                            <TextField
                                fullWidth
                                id="mobile_no"
                                name="mobile_no"
                                type="tel"
                                label="Mobile Number"
                                placeholder="Mobile Number"
                                value={payload.mobile_no}
                                onChange={valupd}
                                error={!!errors.mobile_no}
                                helperText={errors.mobile_no}
                                required
                                variant="outlined"
                                inputProps={{ maxLength: 10 }}
                            />

                            <TextField
                                fullWidth
                                id="sms"
                                name="sms"
                                label="Message"
                                placeholder="Message"
                                value={payload.sms}
                                onChange={valupd}
                                error={!!errors.sms}
                                helperText={errors.sms}
                                required
                                variant="outlined"
                                multiline
                                rows={1}
                            />

                            <Button
                                type="submit"
                                variant="contained"
                                size="large"
                                disabled={loading}
                                sx={{ mt: 2 }}
                            >
                                {loading ? (
                                    <>
                                        <CircularProgress size={24} sx={{ mr: 1 }} color="inherit" />
                                        Submitting...
                                    </>
                                ) : (
                                    'Submit'
                                )}
                            </Button>
                        </Box>

                        {/*  */}


                    </div>

                    {/* text section  */}
                    <div className="textsection">
                        <div className="contactRightSection">
                            <div className="contactInfoCard">
                                <div className="contactInfoItem">
                                    <div className="iconWrapper location">
                                        <MapPin size={24} />
                                    </div>
                                    <p>P-846 Block A, Lake Town, Kolkata-700089 Landmark- Near Bank Of Baroda Laketown</p>
                                </div>

                                <div className="contactInfoItem" style={{ alignItems: 'center' }}>
                                    <div className="iconWrapper email">
                                        <Mail size={24} />
                                    </div>
                                    <p><a href="mailto:info@rbdiagnostics.com"
                                        className="mailLinking">info@rbdiagnostics.com </a></p>
                                </div>

                                <div className="contactInfoItem">
                                    <div className="iconWrapper phone">
                                        <Phone size={24} />
                                    </div>
                                    <div>
                                        <p>033-4085 4085</p>
                                        <p>033-3382 3382</p>
                                        {/* <p>033-4085 4011</p>
                                        <p>033-3382 3311</p> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>





        </div>
    )
}